import React from 'react';

const ImportantNote = () => (
    <div style={{
        backgroundColor: '#fffbeb', /* Fundo Amarelo Claro */
        color: '#92400e',           /* Texto Castanho */
        padding: '16px',
        borderRadius: '12px',
        border: '1px solid #fcd34d', /* Borda Dourada */
        marginBottom: '24px',
        fontSize: '14px',
        lineHeight: '1.5',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        textAlign: 'left',
        width: '100%',
        display: 'block'
    }}>
        <p style={{
            fontWeight: 'bold',
            marginBottom: '8px',
            marginTop: 0,
            fontSize: '15px'
        }}>
            Nota Importante:
        </p>
        <ul style={{
            listStyleType: 'disc',
            listStylePosition: 'inside',
            margin: 0,
            padding: 0,
            color: '#374151'
        }}>
            <li style={{ marginBottom: '4px', fontWeight: '600' }}>As promoções (quando ativas) aplicam-se apenas a comida, excluindo bebidas e menus.</li>
            <li style={{ marginBottom: '4px', fontWeight: '600' }}>A pontualidade é essencial para garantir a reserva.</li>
            <li style={{ fontWeight: '600' }}>Ofertas podem variar conforme a data e hora.</li>
        </ul>
    </div>
);

export default ImportantNote;